import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function Pomeranian() {
  return (
    <>
      <DisplayMaster voivodeship="Pomeranian" />
    </>
  );
}